<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
    <div class="save-panel">
      <button class="btn  btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{'save' | setText('Сохранить')}}
      </button>
    </div>
  </div>
</template>
<script>
import { cardUpdate, cardContent } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "",
    item: null,
    fields: [
      {
        col: 'col-12 col-md-6',
        label: "Номер курса (не изменяемый параметр)",
        key: "course",
        type: "select",
        selectKey: "title",
        modal: "course",
        readonly: true,
        prefix: "group_course_simple",
      },
      {
        key: "title",
        label: "Буква класса",
        type: "field",
        textType: "text",
        col: 'col-12 col-md-6',
      },
      {
        col: 'col-12 col-md-6',
        label: "Сезон",
        key: "season",
        type: "select",
        selectKey: "title",
        modal: "season",
        prefix: "group_season_simple",
      },
    ],
  }),
  props: ["id"],
  async created() {
    this.cardLink = `business/groups/${this.group_id}/courses`;
    this.item = await this.cardContent(this.cardLink, this.course_id);
    this.item['id'] = this.course_id;
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    async updateItem() {
      let item = await this.cardUpdate(this.cardLink, this.item, this.fields);
    },
  },
  computed: {
    course_id: {
      get() {
        return (this.id.split('-')[0]) ? this.id.split('-')[0] : null
      }
    },
    group_id: {
      get() {
        return this.id.split('-')[1] ? this.id.split('-')[1] : null
      }
    },
  }
};
</script>
<style>

</style>
